module.exports = __webpack_public_path__ + "static/media/tstm-walkyria.ca0e7d33.webp";